@file:OptIn(InternalResourceApi::class)

package mobile_wallet.cmp_shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/mobile_wallet.cmp_shared.generated.resources/"

public val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 10, 28),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 10, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10, 28),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 10, 28),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 10, 28),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 10, 28),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 10, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 28),
      ))
    }

public val Res.string.default: StringResource by lazy {
      StringResource("string:default", "default", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39, 27),
      ))
    }

public val Res.string.default_string: StringResource by lazy {
      StringResource("string:default_string", "default_string", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 39, 42),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 39, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 39, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 39, 38),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 39, 54),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 39, 34),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 39, 34),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 39, 42),
      ))
    }

public val Res.string.error_message: StringResource by lazy {
      StringResource("string:error_message", "error_message", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 82, 37),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 86, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 82, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 78, 41),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 94, 53),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 74, 41),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 74, 37),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 82, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 67, 37),
      ))
    }

public val Res.string.faq: StringResource by lazy {
      StringResource("string:faq", "faq", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 120, 51),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 140, 75),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 120, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 120, 15),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 148, 67),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 116, 15),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 112, 39),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 124, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 105, 15),
      ))
    }

public val Res.string.feature_finance_accounts: StringResource by lazy {
      StringResource("string:feature_finance_accounts", "feature_finance_accounts", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 172, 56),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 216, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 160, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 136, 44),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 216, 48),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 132, 40),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 152, 40),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 184, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 121, 44),
      ))
    }

public val Res.string.feature_finance_beneficiaries: StringResource by lazy {
      StringResource("string:feature_finance_beneficiaries", "feature_finance_beneficiaries", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 229, 65),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 289, 77),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 205, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 181, 57),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 265, 69),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 173, 61),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 193, 57),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 229, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166, 57),
      ))
    }

public val Res.string.finance: StringResource by lazy {
      StringResource("string:finance", "finance", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 295, 35),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 367, 31),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 263, 27),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 239, 27),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 335, 35),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 235, 27),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 251, 27),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 279, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 224, 27),
      ))
    }

public val Res.string.history: StringResource by lazy {
      StringResource("string:history", "history", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 331, 31),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 399, 39),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 291, 27),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 267, 31),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 371, 39),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 263, 27),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 279, 31),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 303, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 252, 27),
      ))
    }

public val Res.string.home: StringResource by lazy {
      StringResource("string:home", "home", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 363, 52),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 439, 24),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 319, 20),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 299, 24),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 411, 24),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 291, 24),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 311, 24),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 331, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 280, 20),
      ))
    }

public val Res.string.interbank_server: StringResource by lazy {
      StringResource("string:interbank_server", "interbank_server", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 416, 64),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 464, 100),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 340, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 324, 52),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 436, 80),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 316, 48),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 336, 56),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 352, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 301, 48),
      ))
    }

public val Res.string.main_server: StringResource by lazy {
      StringResource("string:main_server", "main_server", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 481, 55),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 565, 75),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 397, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 377, 43),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 517, 63),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 365, 35),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 393, 43),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 397, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 350, 35),
      ))
    }

public val Res.string.no_interbank_servers: StringResource by lazy {
      StringResource("string:no_interbank_servers", "no_interbank_servers", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 537, 104),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 641, 160),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 441, 88),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 421, 80),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 581, 148),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 401, 84),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 437, 84),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 429, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 386, 68),
      ))
    }

public val Res.string.not_connected: StringResource by lazy {
      StringResource("string:not_connected", "not_connected", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 642, 85),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 802, 149),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 530, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 502, 85),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 730, 129),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 486, 73),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 522, 81),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 506, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 455, 81),
      ))
    }

public val Res.string.payments: StringResource by lazy {
      StringResource("string:payments", "payments", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 728, 40),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 952, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 604, 24),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 588, 28),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 860, 40),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 560, 32),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 604, 32),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 580, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 537, 28),
      ))
    }

public val Res.string.select_instance: StringResource by lazy {
      StringResource("string:select_instance", "select_instance", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 769, 55),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 997, 119),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 629, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 617, 59),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 901, 79),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 593, 43),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 637, 51),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 605, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 566, 43),
      ))
    }

public val Res.string.settings: StringResource by lazy {
      StringResource("string:settings", "settings", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 825, 40),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1117, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 681, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 677, 32),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 981, 48),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 637, 32),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 689, 36),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 645, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 610, 28),
      ))
    }

public val Res.string.tenant_value: StringResource by lazy {
      StringResource("string:tenant_value", "tenant_value", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 866, 52),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1158, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 718, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 710, 44),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1030, 52),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 670, 40),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 726, 36),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 678, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 639, 36),
      ))
    }

public val Res.string.transaction_history: StringResource by lazy {
      StringResource("string:transaction_history", "transaction_history", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 919, 63),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1223, 87),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 755, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 755, 63),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1083, 87),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 711, 51),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 763, 63),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 719, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 676, 55),
      ))
    }

public val Res.string.update: StringResource by lazy {
      StringResource("string:update", "update", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 983, 30),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1311, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 819, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 819, 34),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1171, 54),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 763, 26),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 827, 26),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 775, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 732, 22),
      ))
    }

public val Res.string.upi_and_autopay: StringResource by lazy {
      StringResource("string:upi_and_autopay", "upi_and_autopay", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 755, 55),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("app_name", Res.string.app_name)
  map.put("default", Res.string.default)
  map.put("default_string", Res.string.default_string)
  map.put("error_message", Res.string.error_message)
  map.put("faq", Res.string.faq)
  map.put("feature_finance_accounts", Res.string.feature_finance_accounts)
  map.put("feature_finance_beneficiaries", Res.string.feature_finance_beneficiaries)
  map.put("finance", Res.string.finance)
  map.put("history", Res.string.history)
  map.put("home", Res.string.home)
  map.put("interbank_server", Res.string.interbank_server)
  map.put("main_server", Res.string.main_server)
  map.put("no_interbank_servers", Res.string.no_interbank_servers)
  map.put("not_connected", Res.string.not_connected)
  map.put("payments", Res.string.payments)
  map.put("select_instance", Res.string.select_instance)
  map.put("settings", Res.string.settings)
  map.put("tenant_value", Res.string.tenant_value)
  map.put("transaction_history", Res.string.transaction_history)
  map.put("update", Res.string.update)
  map.put("upi_and_autopay", Res.string.upi_and_autopay)
}
